<template>
    <client-page>
        <sub-visual sh="About IST" tabActive="Company History" bg="/images/sub/visual/sv1.png"> </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <h2 class="page-tit">Company History</h2>
            </v-container>
            <top-image src="/images/sub/about/history/his-img1.png"> </top-image>
            <v-container>
                <v-row>
                    <v-col cols="12" md="4" lg="5">
                        <div class="his-year text-center text-md-left pa-16 pa-md-30 py-lg-60 pl-lg-70 pr-lg-90 line-height-1 color-white mb-6 mb-md-0 mt-30 mt-md-0">
                            <p class="page-text-lg mb-8 mb-lg-20">History of the IST</p>
                            <h2 class="poppins font-weight-semibold font-size-30 font-size-lg-54 text-md-right d-inline-block d-md-block">2022<span class="d-inline-block d-md-none mx-6">~</span></h2>
                            <h2 class="poppins font-weight-semibold font-size-30 font-size-lg-54 d-inline-block d-md-block mt-n4">2012 <span class="d-none d-md-inline-block">~</span></h2>
                        </div>
                    </v-col>
                    <v-col cols="12" md="8" lg="7">
                        <div class="pl-md-24 pl-lg-50 pt-md-50 pt-lg-120 his-detail overflow-hidden">
                            <div class="d-flex align-center mb-8 mb-md-24 mb-lg-54">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">2022</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">ISO 45001 : 2018 안전보건경영시스템 인증서 취득</p>
                            </div>
                            <div class="d-flex align-center mb-8 mb-md-24 mb-lg-54">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">2022</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">스마트공장 사업 3차 진행 (고도화) (2019년~)</p>
                            </div>
                            <div class="d-flex align-center mb-8 mb-md-24 mb-lg-54">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">2022</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">ISO 27001 : 2013 정보보안경영시스템 인증서 취득</p>
                            </div>
                            <div class="d-flex align-center mb-8 mb-md-24 mb-lg-54">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">2014</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">사명 변경 ( IS Techno Co. Ltd. 에서 IST Co.,Ltd. )</p>
                            </div>
                            <div class="d-flex align-center">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">2012</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">ISO 14001 : 2015 환경경영 시스템 인증서 취득</p>
                            </div>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="sub-section">
            <top-image src="/images/sub/about/history/his-img2.png"> </top-image>
            <v-container>
                <v-row class="flex-column-reverse flex-md-row justify-start">
                    <v-col cols="12" md="8" lg="7">
                        <div class="pl-md-24 pl-lg-50 pt-md-50 pt-lg-120 his-detail overflow-hidden">
                            <div class="d-flex align-center mb-8 mb-md-24 mb-lg-54">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">2008</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">기업부설 연구소 설립 (제2008110774호)</p>
                            </div>
                            <div class="d-flex align-center mb-8 mb-md-24 mb-lg-54">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">2007</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">ISO 9001 : 2015 품질경영시스템 인증서 취득</p>
                            </div>
                            <div class="d-flex align-center mb-8 mb-md-24 mb-lg-54">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">2003</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">IST USA Inc. 미국 현지법인 설립</p>
                            </div>
                            <div class="d-flex align-center">
                                <div class="d-flex flex-row-reverse flex-md-row align-center mr-16 mr-md-20 mr-lg-40">
                                    <h3 class="poppins tit line-hieght-1">1996</h3>
                                    <span class="d-block mr-6 mr-md-0 ml-md-20 ml-lg-40 his-point"></span>
                                </div>
                                <p class="page-text color-grey-51">IS Techno Ltd. 설립</p>
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="4" lg="5" class="d-flex justify-md-end">
                        <div class="his-year text-center text-md-left pa-16 pa-md-30 py-lg-60 pl-lg-70 pr-lg-90 line-height-1 color-white mb-6 mb-md-0 mt-30 mt-md-0">
                            <p class="page-text-lg mb-8 mb-lg-20">History of the IST</p>
                            <h2 class="poppins font-weight-semibold font-size-30 font-size-lg-54 text-md-right d-inline-block d-md-block">2008<span class="d-inline-block d-md-none mx-6">~</span></h2>
                            <h2 class="poppins font-weight-semibold font-size-30 font-size-lg-54 d-inline-block d-md-block mt-n4">1996 <span class="d-none d-md-inline-block">~</span></h2>
                        </div>
                    </v-col>
                </v-row>
            </v-container>
        </section>

        <section class="sub-section sub-section--last">
            <v-container>
                <div class="history-text">
                    <p class="tit font-weight-bold text-center">
                        최고 최상 품질의CMP Retainer Ring 가공 및 <br class="d-none d-sm-block" />
                        반도체 설비 소모품 · 장비 유통 기업
                    </p>
                </div>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import TopImage from "@/components/client/ko/sub/sub-top-image.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        TopImage,
    },
};
</script>

<style lang="scss" scoped>
.his-point {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: 1px solid var(--border-color);
    background-color: #fff;
    position: relative;
}
.his-point::after {
    content: "";
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: var(--v-primary-base);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.his-year {
    position: relative;
    z-index: 1;
    width: 100%;
    background-color: var(--v-primary-base);
    height: fit-content;
}

.his-detail h3 {
    min-width: 49px;
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .his-year {
        width: 410px;
        max-width: 100%;
        top: -100px;
    }
    .his-detail {
        position: relative;
    }
    .his-detail::before {
        content: "";
        display: block;
        position: absolute;
        z-index: 0;
        width: 1px;
        height: 100%;
        background-color: var(--border-color);
        bottom: 16px;
        left: 122px;
    }
    .his-detail h3 {
        min-width: 74px;
    }
}
@media (min-width: 1024px) {
    .his-year {
        top: -150px;
    }
    .his-point {
        width: 16px;
        height: 16px;
    }
    .his-point::after {
        width: 8px;
        height: 8px;
    }
    .his-detail::before {
        bottom: 20px;
        left: 182px;
    }
    .his-detail h3 {
        min-width: 84px;
    }
}
@media (min-width: 1200px) {
}
</style>